/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DeliveryBoxFrontOpenIcon16Light } from './DeliveryBoxFrontOpenIcon16Light';
import { DeliveryBoxFrontOpenIcon16Regular } from './DeliveryBoxFrontOpenIcon16Regular';
import { DeliveryBoxFrontOpenIcon16Solid } from './DeliveryBoxFrontOpenIcon16Solid';
import { DeliveryBoxFrontOpenIcon20Light } from './DeliveryBoxFrontOpenIcon20Light';
import { DeliveryBoxFrontOpenIcon20Regular } from './DeliveryBoxFrontOpenIcon20Regular';
import { DeliveryBoxFrontOpenIcon20Solid } from './DeliveryBoxFrontOpenIcon20Solid';
import { DeliveryBoxFrontOpenIcon24Regular } from './DeliveryBoxFrontOpenIcon24Regular';
import { DeliveryBoxFrontOpenIcon24Solid } from './DeliveryBoxFrontOpenIcon24Solid';
import { DeliveryBoxFrontOpenIcon32Regular } from './DeliveryBoxFrontOpenIcon32Regular';
import { DeliveryBoxFrontOpenIcon64Regular } from './DeliveryBoxFrontOpenIcon64Regular';
var sizes = {
    16: {
        light: DeliveryBoxFrontOpenIcon16Light,
        regular: DeliveryBoxFrontOpenIcon16Regular,
        solid: DeliveryBoxFrontOpenIcon16Solid,
    },
    20: {
        light: DeliveryBoxFrontOpenIcon20Light,
        regular: DeliveryBoxFrontOpenIcon20Regular,
        solid: DeliveryBoxFrontOpenIcon20Solid,
    },
    24: {
        regular: DeliveryBoxFrontOpenIcon24Regular,
        solid: DeliveryBoxFrontOpenIcon24Solid,
    },
    32: {
        regular: DeliveryBoxFrontOpenIcon32Regular,
    },
    64: {
        regular: DeliveryBoxFrontOpenIcon64Regular,
    },
};
export var DeliveryBoxFrontOpenIcon = forwardRef('DeliveryBoxFrontOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
